<script>
  import { Link } from "svelte-routing";
  import metacombined from "./metacombined.json";

  import Body from "./Body.svelte";
  import Navbar from "./Navbar.svelte";

  let boys = Object.keys(metacombined)
    .map((key) => [key, metacombined[key]])
    .sort(() => Math.random() - 0.5)
    .slice(0, 10)
    .map(([key, meta]) => ({
      name: meta.name.toLowerCase().replace(/[^a-z]/g, ""),
      title: meta.name,
      id: key,
    }));
</script>

<div class="bg-pinkSplash">
  <Navbar />
  <header class="py-24 font-pixel text-center color-gray-700 display-block">
    <a
      href="/"
      class="display-block text-4xl md:text-7xl lg:text-10xl"
      style="font-size: 10vw"
    >
      <span class="text-gray-900">CRYPTOFUCKBOYS</span>
    </a>
    <h4 class="mt-4 text-xl md:text-4xl">so cute you want to take them home</h4>
  </header>
</div>

<div class="bg-pinkSplash">
  <div class="flex justify-center">
    <section class="grid grid-cols-3 min-w-full md:grid-cols-5">
      {#each boys as boy}
        <Link to="/boy/{boy.id}">
          <img
            src="boys/render_frame1/{boy.name}_1.png"
            alt="{boy.title}"
          />
        </Link>
      {/each}
    </section>
  </div>
</div>

<div class="bg-pinkSplash py-14 px-20">
  <Body />
</div>

<style>
</style>
